module.exports = __webpack_public_path__ + "img/icon_5_61.2d40cbc7.png";